export const CartDrawerFooter = ({
  itemCount,
  subtotal,
  busy,
  checkoutBusy,
  formatCurrency,
  totalQuantityLabel,
  totalPriceLabel,
  checkoutBusyLabel,
  checkoutLabel,
  continueShoppingLabel,
  onCheckout,
  onContinueShopping,
}: {
  itemCount: number
  subtotal: number
  busy: boolean
  checkoutBusy: boolean
  formatCurrency: (value: number) => string
  totalQuantityLabel: string
  totalPriceLabel: string
  checkoutBusyLabel: string
  checkoutLabel: string
  continueShoppingLabel: string
  onCheckout: () => void
  onContinueShopping: () => void
}) => (
  <footer className="border-t border-slate-200 bg-white px-4 py-3">
    <div className="mb-3 space-y-1 text-sm">
      <div className="flex items-center justify-between text-slate-700">
        <span>{totalQuantityLabel}</span>
        <span className="font-semibold text-slate-900">{itemCount}</span>
      </div>
      <div className="flex items-center justify-between text-base">
        <span className="font-semibold text-slate-900">{totalPriceLabel}</span>
        <span className="font-bold text-emerald-700">{formatCurrency(subtotal)}</span>
      </div>
    </div>
    <button
      type="button"
      className="w-full rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-300"
      onClick={onCheckout}
      disabled={busy || checkoutBusy || itemCount === 0}
    >
      {checkoutBusy ? checkoutBusyLabel : checkoutLabel}
    </button>
    <button
      type="button"
      className="mt-2 w-full rounded-lg border border-slate-300 bg-white px-4 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50"
      onClick={onContinueShopping}
    >
      {continueShoppingLabel}
    </button>
  </footer>
)
